import { invokeApi } from "../../bl_libs/invokeApi";

const getAuthHeader = () => ({
  "x-sh-auth": localStorage.getItem("token"),
});

export const getPaymentsOverview = async (days = 30) => {
  return invokeApi({
    path: `api/admin/payments/overview?days=${days}`,
    method: "GET",
    headers: getAuthHeader(),
  });
};

export const getUserPaymentDetails = async (userId) => {
  return invokeApi({
    path: `api/admin/payments/user/${userId}`,
    method: "GET",
    headers: getAuthHeader(),
  });
};
